/* Home: hero photos, community sound, community wall filter (from the approved prototype). */
(function(){

const $=s=>document.querySelector(s),$$=s=>[...document.querySelectorAll(s)];
/* hero video: pause for people who want it still (WCAG 2.2.2) */
/* hero: real photos, slow crossfade, AURA first and longest; pause button (WCAG 2.2.2), bars to jump, still for reduced motion */
const SL=$$('#heroSlides .sl'),HB=$$('#heroBars button'),hd=$('#heroDev'),hp=$('#heroPause'),hs=$('.hero3');
const HOLD=[6500,5000,5000,5000,5000,5000];let hi=0,ht=null,hpaused=matchMedia('(prefers-reduced-motion: reduce)').matches;
function hshow(n){SL[hi].classList.remove('on');HB[hi].classList.remove('on');hi=(n+SL.length)%SL.length;SL[hi].classList.add('on');HB[hi].classList.add('on');
  hd.classList.add('sw');setTimeout(()=>{hd.querySelector('b').textContent=SL[hi].dataset.name;hd.querySelector('span').textContent=SL[hi].dataset.price;hd.classList.remove('sw')},200);hnext()}
function hnext(){clearTimeout(ht);if(!hpaused)ht=setTimeout(()=>hshow(hi+1),HOLD[hi]||5000)}
HB.forEach((b,i)=>b.addEventListener('click',()=>hshow(i)));
function hset(p){hpaused=p;hs.classList.toggle('still',p);hp.setAttribute('aria-pressed',String(p));hp.setAttribute('aria-label',p?(window.BEEA.t.play_photos):(window.BEEA.t.pause_photos));p?clearTimeout(ht):hnext()}
hp.addEventListener('click',()=>hset(!hpaused));
hset(hpaused);
/* community videos: sound on tap, one at a time, with captions */
const CUES={'ugc-aura.mp4':[[1.8,2.8,'Ovo je AURA.'],[2.8,5.1,'Već neko vrijeme dio je moje dnevne rutine,'],[5.1,6.1,'jer je tretman jako brz.']]};
const MUSIC=window.BEEA.t.music;
function mute(card){const v=card.querySelector('video');v.muted=true;card.classList.remove('on');const b=card.querySelector('.snd');if(b){b.setAttribute('aria-pressed','false');b.setAttribute('aria-label',(window.BEEA.t.sound_on))}card.querySelector('.cap').textContent=''}
$$('.shoprow .snd').forEach(b=>b.addEventListener('click',()=>{
  const card=b.closest('.vcard'),v=card.querySelector('video'),on=card.classList.contains('on');
  $$('.shoprow .vcard.on').forEach(mute);
  if(on)return;
  card.classList.add('on');v.muted=false;try{v.currentTime=0;v.play().catch(()=>{})}catch(x){}
  b.setAttribute('aria-pressed','true');b.setAttribute('aria-label',(window.BEEA.t.sound_off));
  card.querySelector('.cap').textContent=CUES[card.dataset.v]?'':MUSIC;
}));
$$('.shoprow .vcard video').forEach(v=>v.addEventListener('timeupdate',()=>{
  const card=v.closest('.vcard'),c=CUES[card.dataset.v];if(!c||!card.classList.contains('on'))return;
  const t=v.currentTime,cue=c.find(x=>t>=x[0]&&t<x[1]);card.querySelector('.cap').textContent=cue?cue[2]:'';
}));
/* community grid: filter by device, clips play on hover or tap */
const NAMES={rems:'REMS REVIVE',sculpta:'SCULPTA',vita:'VITA'};
$('#gchips')&&$('#gchips').addEventListener('click',e=>{
  const c=e.target.closest('.chip');if(!c)return;
  $$('#gchips .chip').forEach(x=>x.classList.toggle('on',x===c));
  const f=c.dataset.f;let shown=0;
  $$('#wallg .gt').forEach(t=>{const ok=f==='all'||t.dataset.dev===f;t.style.display=ok?'':'none';if(ok)shown++});
  $('#gempty').classList.toggle('on',shown===0);if(NAMES[f])$('#gname').textContent=NAMES[f];
});
$$('#wallg .gt.vid').forEach(t=>{const v=t.querySelector('video');
  const play=()=>{t.classList.add('playing');try{v.play().catch(()=>{})}catch(x){}};
  const stop=()=>{t.classList.remove('playing');try{v.pause()}catch(x){}};
  t.addEventListener('mouseenter',play);t.addEventListener('mouseleave',stop);
  t.addEventListener('click',e=>{if(!t.classList.contains('playing')){e.preventDefault();play()}});
});

/* community wall: one row, swipe or arrows; chips reset the row */
(function(){const g=document.getElementById('wallg');if(!g)return;const pv=document.getElementById('wprev'),nx=document.getElementById('wnext'),bar=document.getElementById('wbar');
const vis=()=>[].filter.call(g.querySelectorAll('.gt'),t=>t.style.display!=='none');
const gap=()=>parseFloat(getComputedStyle(g).columnGap)||14;
const step=()=>{const t=vis()[0];if(!t)return g.clientWidth;const w=t.getBoundingClientRect().width+gap();return w*Math.max(1,Math.floor((g.clientWidth+gap())/w))};
const upd=()=>{const max=g.scrollWidth-g.clientWidth;if(pv)pv.disabled=g.scrollLeft<=2;if(nx)nx.disabled=g.scrollLeft>=max-2;
  if(bar){const r=Math.min(1,g.clientWidth/Math.max(1,g.scrollWidth));bar.style.width=(r*100)+'%';bar.parentNode.style.visibility=r>=1?'hidden':'';bar.style.transform='translateX('+(max>0?g.scrollLeft/max*(1/r-1)*100:0)+'%)'}};
pv&&pv.addEventListener('click',()=>g.scrollBy({left:-step(),behavior:'smooth'}));
nx&&nx.addEventListener('click',()=>g.scrollBy({left:step(),behavior:'smooth'}));
g.addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);
const ch=document.getElementById('gchips');ch&&ch.addEventListener('click',e=>{const c=e.target.closest('.chip');if(!c)return;
  [].forEach.call(ch.querySelectorAll('.chip'),x=>x.setAttribute('aria-pressed',String(x===c)));g.scrollLeft=0;requestAnimationFrame(upd)});
upd();})();

/* top community row: a video plays only while its card is on screen; nothing loads before that */
(function(){const vs=[].slice.call(document.querySelectorAll('.shoprow .vcard video'));if(!vs.length)return;
const still=matchMedia('(prefers-reduced-motion: reduce)').matches;
const go=v=>{if(still)return;const p=v.play();p&&p.catch&&p.catch(()=>{})};
if(!('IntersectionObserver' in window)){vs.forEach(go);return}
const io=new IntersectionObserver(es=>es.forEach(e=>{const v=e.target;if(e.intersectionRatio>=.6)go(v);else if(!v.paused)v.pause()}),{threshold:[0,.6]});
vs.forEach(v=>io.observe(v));})();

})();
